import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

function Pricing() {
  return (
  <>
    <Navbar/>
    <div className='news-banner'>
    <p>Pricing</p>
    <br/>
    <h3> Pricing for Cine Celebrate</h3>

    </div>
    <div className='Pricing-div'>
    <div className='Pricing-card'>
    <h3>Monthly</h3>
    <br/>
    <p>All bookings must be made in advance through official communication channels (website, phone, or in-person).</p>
    <br/>
    <div className='Pricing-ul'>

<ul>
    <li>Fullpaymentpayment payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>

</ul>
    </div>

    <br/>
    <h3>1000 Rs</h3>
    <br/>
<button>Get This Plan</button>
    </div>
    <div className='Pricing-card'>
    <h3>Monthly</h3>
    <br/>
    <p>All bookings must be made in advance through official communication channels (website, phone, or in-person).</p>
    <br/>
    <div className='Pricing-ul'>

<ul>
    <li>Fullpaymentpayment payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>

</ul>
    </div>

    <br/>
    <h3>1000 Rs</h3>
    <br/>
<button>Get This Plan</button>
    </div>
    <div className='Pricing-card'>
    <h3>Monthly</h3>
    <br/>
    <p>All bookings must be made in advance through official communication channels (website, phone, or in-person).</p>
    <br/>
    <div className='Pricing-ul'>

<ul>
    <li>Fullpaymentpayment payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>
    <li>Full payment is required to confirm the booking.</li>

</ul>
    </div>

    <br/>
    <h3>1000 Rs</h3>
    <br/>
<button>Get This Plan</button>
    </div>

    </div>
    <Footer/>
  </>
  )
}

export default Pricing